import { PRIMITIVE_JS_VALUE, JS_OBJECT, IMMUTABLE_MAP, IMMUTABLE_LIST, NestedImmutableMap, IMMUTABLE_SET, IMMUTABLE_MAP_OF_LAYOUT_TREES, IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES, ALLOWLISTED_SCHEMA_OBJECT

// @ts-expect-error module not migrated yet
} from 'ContentEditorUI/redux/inpageSync/types';
import emailBasicSyncConfig from './emailBasicSyncConfig';
export default Object.assign({}, emailBasicSyncConfig, {
  configValues: JS_OBJECT,
  emailTemplateSchema: ALLOWLISTED_SCHEMA_OBJECT,
  critsit: JS_OBJECT,
  ctas: JS_OBJECT,
  contentModel: IMMUTABLE_MAP,
  defaultSettings: JS_OBJECT,
  defaultStyleSettings: JS_OBJECT,
  modules: {
    immutable: true,
    allowlist: ['present', 'redoCount', 'undoCount'],
    nestedConfig: {
      redoCount: PRIMITIVE_JS_VALUE,
      undoCount: PRIMITIVE_JS_VALUE,
      present: NestedImmutableMap({
        uneditableWidgets: IMMUTABLE_MAP,
        schemaLayoutSectionTrees: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        layoutSectionTrees: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        gridLayoutTrees: IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES,
        schemaGridLayoutTrees: IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES,
        schemaGridLayoutWidgets: IMMUTABLE_MAP,
        layoutSectionWidgets: IMMUTABLE_MAP,
        schemaWidgetContainers: IMMUTABLE_MAP,
        widgetContainers: IMMUTABLE_MAP,
        schemaWidgets: IMMUTABLE_MAP,
        fakeModules: IMMUTABLE_MAP,
        widgets: IMMUTABLE_MAP,
        widgetsInRichText: IMMUTABLE_MAP,
        contentCss: IMMUTABLE_MAP,
        moduleMetaData: IMMUTABLE_MAP,
        clonedModulesPendingDomOperations: IMMUTABLE_SET,
        themePageOverrides: JS_OBJECT,
        // email only
        flexAreaSections: IMMUTABLE_LIST,
        flexAreaStyles: IMMUTABLE_MAP,
        flexAreaStyleSettings: IMMUTABLE_MAP,
        userModuleDefaults: IMMUTABLE_MAP
      })
    }
  },
  savedSections: JS_OBJECT,
  routing: JS_OBJECT,
  socialNetworks: JS_OBJECT,
  userAttributes: JS_OBJECT,
  paymentsEligibility: JS_OBJECT
});